<template>
  <div class="container mt-5">
    <div class="section-title">
      <h2>Ophthalmology</h2>
      <p>
        The department of Ophthalmology offers diagnostic and therapeutic
        services for all common ophthalmic conditions for the young and the old.
      </p>
    </div>
  </div>
  <DoctorsList :name="name" :queryName="queryName" :teamName="teamName" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DoctorsList from "@/components/Departments/common/DoctorsListTemplate2.vue";
import { DepartmentPropDataInterface } from "@/ts/interfaces";

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: "Ophthalmology Doctors",
      queryName: "Ophthalmology",
      teamName: "Ophthalmology team",
    };
  },
  components: { DoctorsList },
});
</script>

<style scoped lang="scss">
@import "@/scss/sectionTemplate2.scss";
</style>
